module.exports = __webpack_public_path__ + "img/browser-frame.fca52434.png";